import { Button, Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useHistoryWithReturnUrl from 'hooks/useHistoryWithReturnUrl/useHistoryWithReturnUrl'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import InvertPrimaryButton from 'components/Buttons/InvertPrimaryButton'
import { ButtonProps } from '@mui/material/Button/Button'

export const BUTTON_DISCARD_TEXT = 'button.discard'
export const BUTTON_SAVE_TEXT = 'button.save'

export interface EditActionPanelProps {
    onSave: () => void
    onDiscard?: () => void
    disabled?: boolean
    saveDisabled?: boolean
    discardText?: string
    saveText?: string
    focusSaveButton?: boolean
    style?: React.CSSProperties
    className?: string
    hideConfirmBtn?: boolean
    hideDiscardBtn?: boolean
    isSubmitType?: boolean
    form?: string
    saveColor?: ButtonProps['color']
    discardColor?: ButtonProps['color']
    buttonHeight?: number | string
    fullButtons?: boolean
}

export default function EditActionPanel({
    onSave,
    onDiscard,
    disabled = false,
    saveDisabled = false,
    discardText = BUTTON_DISCARD_TEXT,
    saveText = BUTTON_SAVE_TEXT,
    focusSaveButton = false,
    hideConfirmBtn = false,
    hideDiscardBtn = false,
    style,
    className,
    isSubmitType,
    form,
    saveColor,
    discardColor,
    buttonHeight,
    fullButtons = false,
}: EditActionPanelProps) {
    const { t } = useTranslation()
    const history = useHistoryWithReturnUrl()
    const { isMobile } = useScreenSize()

    return (
        <Grid
            container
            justifyContent="flex-end"
            spacing={isMobile ? 1 : 2}
            style={style}
            className={className}
        >
            {!hideDiscardBtn && (
                <Grid
                    item
                    xs={
                        fullButtons || isMobile
                            ? hideConfirmBtn
                                ? 12
                                : 6
                            : 'auto'
                    }
                >
                    {(fullButtons || isMobile) && !discardColor ? (
                        <InvertPrimaryButton
                            onClick={() => {
                                if (onDiscard) onDiscard()
                                else history.goBack()
                            }}
                            title={t(discardText)}
                            sx={{ height: buttonHeight }}
                            disabled={disabled}
                            fullWidth
                        />
                    ) : (
                        <Button
                            className="textUpper"
                            color={discardColor || 'secondary'}
                            onClick={() => {
                                if (onDiscard) onDiscard()
                                else history.goBack()
                            }}
                            disabled={disabled}
                            fullWidth
                            sx={{ height: buttonHeight }}
                        >
                            {t(discardText)}
                        </Button>
                    )}
                </Grid>
            )}
            {!hideConfirmBtn && (
                <Grid
                    item
                    xs={
                        fullButtons || isMobile
                            ? hideDiscardBtn
                                ? 12
                                : 6
                            : 'auto'
                    }
                >
                    <Button
                        type={isSubmitType ? 'submit' : 'button'}
                        className="textUpper"
                        color={saveColor || 'primary'}
                        onClick={(e) => {
                            e.stopPropagation()
                            onSave()
                        }}
                        disabled={disabled || saveDisabled}
                        autoFocus={focusSaveButton}
                        form={form}
                        sx={{ height: buttonHeight }}
                        fullWidth
                    >
                        {t(saveText)}
                    </Button>
                </Grid>
            )}
        </Grid>
    )
}
